import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const editor = new Restful(project, 'editor')

editor.withdraw = function(id, data) {
  const url = project + 'editor/withdraw/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

editor.dismiss = function(id, data) {
  const url = project + 'editor/dismiss/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

editor.reviseTime = function(id, data) {
  const url = project + 'editor/revise/time/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
editor.reviseRemind = function(id, data) {
  const url = project + 'editor/revise/remind/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

editor.decision = function(id, data) {
  const url = project + 'editor/decision/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

// editor.decision = function(id, data) {
//   const url = project + 'editor/decision/' + id
//   return http.get(url, data).then(res => {
//     return res
//   })
// }

editor.authorQuestionnaire = function(id, data) {
  const url = project + 'editor/author/questionnaire/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

editor.manuscriptQuestionnaire = function(id, data) {
  const url = project + 'editor/manuscript/author/questionnaire/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

editor.transfer = function(id, data) {
  const url = project + 'editor/transfer/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

// 拒绝理由列表
editor.refuse = function(data) {
  const url = project + 'editor/refuse'
  return http.get(url, data).then(res => {
    return res
  })
}

const editorAssign = new Restful(project, 'editor/assigned')

const editorManuscript = new Restful(project, 'editor/manuscript')
editorManuscript.status = function(data) {
  const url = project + 'editor/manuscript/status'
  return http.get(url, data).then(res => {
    return res
  })
}
editorManuscript.remark = function(id, data) {
  const url = project + 'editor/manuscript/remark/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
editorManuscript.specialRemark = function(id, data) {
  const url = project + 'editor/manuscript/special/remark/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
// 稿件检查
editorManuscript.check = function(id, data) {
  const url = project + 'editor/manuscript/check/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

const editorDecision = new Restful(project, 'editor/decision')
editorDecision.history = function(id, data) {
  const url = project + 'editor/decision/history/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
editorDecision.save = function(data) {
  const url = project + 'editor/decision/save'
  return http.put(url, data).then(res => {
    return res
  })
}
// 提交至最终决策
editorDecision.final = function(data) {
  const url = project + 'editor/decision/final'
  return http.put(url, data).then(res => {
    return res
  })
}
// 提交至作者
editorDecision.author = function(data) {
  const url = project + 'editor/decision/final/author'
  return http.put(url, data).then(res => {
    return res
  })
}
editorDecision.getAuthorRevise = function(data) {
  const url = project + 'editor/decision/revision'
  return http.get(url, data).then(res => {
    return res
  })
}

editorDecision.setAuthorRevise = function(id, data) {
  const url = project + `editor/revise/remind/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

// 最终决策详情
const editorFinal = new Restful(project, 'editor/final')
editorFinal.decision = function(data) {
  const url = project + 'editor/decision/final'
  return http.get(url, data).then(res => {
    return res
  })
}

export { editor, editorAssign, editorManuscript, editorDecision, editorFinal }
